import { render, staticRenderFns } from "./SwiperNavigation.vue?vue&type=template&id=2b413335&"
import script from "./SwiperNavigation.vue?vue&type=script&lang=js&"
export * from "./SwiperNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports